import * as types from 'store/modules/hrmsDropzone/mutation-types'
import hrmsDropzone from 'api/hrmsDropzone'
import swal from 'sweetalert'

export default {
  actions: {
    [types.POST_HRMS_DROPZONE_REMOVED_FILE] ({ commit }, { file, fileDir }) {
      hrmsDropzone.postRemovedFile({ file, fileDir })
        .then((response) => {
          // const data = JSON.parse(response.request.response)
          // swal({
          //   title: '', text: data.response, html: true, type: 'success'
          // }, function () {
          //   window.onkeydown = null; window.onfocus = null; swal('')
          // })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/hrmsDropzone/index.js